export const pluralTosingular = (text) => {
  const obj = {
    topics: 'topic',
    events: 'event'
  };

  return obj[text] || text;

};